import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { credentialByKey } from "@/lib/credentials";
import { Check } from "lucide-react";

interface EarnedBadgesProps {
  userId: string;
}

interface EarnedRow {
  credential_key: string;
  earned_on: string | null;
}

export default function EarnedBadges({ userId }: EarnedBadgesProps) {
  const [earned, setEarned] = useState<EarnedRow[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    supabase
      .rpc("get_public_earned_credentials", { _user_id: userId })
      .then(({ data, error }) => {
        if (cancelled) return;
        if (!error && data) {
          setEarned(data as EarnedRow[]);
        }
        setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [userId]);

  if (loading) return null;
  if (earned.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2 mt-4">
      {earned.map((row) => {
        const def = credentialByKey(row.credential_key);
        if (!def) return null;
        const Icon = def.icon;
        return (
          <span
            key={row.credential_key}
            className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs border bg-primary/10 text-primary border-primary/30"
            title={def.blurb}
          >
            <Check className="h-3 w-3 shrink-0" />
            <Icon className="h-3.5 w-3.5 shrink-0" />
            <span className="font-medium">{def.label}</span>
            {row.earned_on && (
              <span className="text-[10px] text-primary/70">
                {new Date(row.earned_on).getFullYear()}
              </span>
            )}
          </span>
        );
      })}
    </div>
  );
}
